// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* new */
.SignupGrid-providerAppBgWrapper-B_zXn {
    background-position: center;
    background-size: cover;
    padding: 35px 108px;
    background-color: var(--common-gray-bg);
    border-radius: 0 24px 0 24px;
    margin-top: 42px;
}
.SignupGrid-providerAppRowGrid-bTinu {
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    display: grid;
    grid-template-columns: 1fr 350px;
    gap: 20px;
}
.SignupGrid-providerAppHeading-y4XUi {
    font-size: 36px;
    line-height: 46px;
    font-weight: 700;
    color: var(--common-primary-foreground);
    margin: 0 0 18px;
}
.SignupGrid-providerAppDesc-AtJPM {
    font-size: 18px;
    line-height: 28px;
    font-weight: 500;
    color: var(--common-primary-foreground);
    margin: 0 0 30px;
}
.SignupGrid-providerAppBtnGroup-pE0Gw {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 12px;
}
.SignupGrid-providerAppBtnLink-XrM6S {
    max-width: 168px;
    width: 100%;
    display: inline-block;
}
.SignupGrid-providerAppBtnLink-XrM6S img {
    width: 100%;
    height: 100%;
}
.SignupGrid-providerAppImageWrapper-Wqj2Y {
    max-width: 300px;
    height: 470px;
    margin-left: auto;
}
.SignupGrid-providerAppImageWrapper-Wqj2Y>img {
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
}
.SignupGrid-noTopCategoryBottomSpace-aA2Pq {
    margin-bottom: 42px;
}
@media (min-width:1200px) {
    .SignupGrid-providerAppRowGrid-bTinu {
        grid-template-columns: 1fr 400px;
    }
}
@media (max-width:991px) {
    .SignupGrid-providerAppBgWrapper-B_zXn {
        padding: 35px 30px;
    }

    .SignupGrid-providerAppImageWrapper-Wqj2Y {
        margin: auto;
    }
}
@media (max-width:767px) {
    .SignupGrid-providerAppBgWrapper-B_zXn {
        padding: 35px 15px;
    }

    .SignupGrid-providerAppRowGrid-bTinu {
        grid-template-columns: 100%;
    }

    .SignupGrid-providerAppImageWrapper-Wqj2Y {
        height: 370px;
    }

    .SignupGrid-providerAppHeading-y4XUi {
        font-size: 24px;
        line-height: 32px;
        margin: 0 0 16px;
    }

    .SignupGrid-providerAppDesc-AtJPM {
        font-size: 16px;
        line-height: 24px;
        margin: 0 0 24px;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/Home/SignupGrid/SignupGrid.css"],"names":[],"mappings":"AAAA,QAAQ;AACR;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,uCAAuC;IACvC,4BAA4B;IAC5B,gBAAgB;AACpB;AAEA;IACI,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,SAAS;AACb;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uCAAuC;IACvC,gBAAgB;AACpB;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uCAAuC;IACvC,gBAAgB;AACpB;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,mBAAe;QAAf,eAAe;IACf,SAAS;AACb;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,iBAAiB;AACrB;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;AAEA;IACI,mBAAmB;AACvB;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;AACJ;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;AAEJ","sourcesContent":["/* new */\n.providerAppBgWrapper {\n    background-position: center;\n    background-size: cover;\n    padding: 35px 108px;\n    background-color: var(--common-gray-bg);\n    border-radius: 0 24px 0 24px;\n    margin-top: 42px;\n}\n\n.providerAppRowGrid {\n    align-items: center;\n    display: grid;\n    grid-template-columns: 1fr 350px;\n    gap: 20px;\n}\n\n.providerAppHeading {\n    font-size: 36px;\n    line-height: 46px;\n    font-weight: 700;\n    color: var(--common-primary-foreground);\n    margin: 0 0 18px;\n}\n\n.providerAppDesc {\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: 500;\n    color: var(--common-primary-foreground);\n    margin: 0 0 30px;\n}\n\n.providerAppBtnGroup {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.providerAppBtnLink {\n    max-width: 168px;\n    width: 100%;\n    display: inline-block;\n}\n\n.providerAppBtnLink img {\n    width: 100%;\n    height: 100%;\n}\n\n.providerAppImageWrapper {\n    max-width: 300px;\n    height: 470px;\n    margin-left: auto;\n}\n\n.providerAppImageWrapper>img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.noTopCategoryBottomSpace {\n    margin-bottom: 42px;\n}\n\n@media (min-width:1200px) {\n    .providerAppRowGrid {\n        grid-template-columns: 1fr 400px;\n    }\n}\n\n@media (max-width:991px) {\n    .providerAppBgWrapper {\n        padding: 35px 30px;\n    }\n\n    .providerAppImageWrapper {\n        margin: auto;\n    }\n}\n\n@media (max-width:767px) {\n    .providerAppBgWrapper {\n        padding: 35px 15px;\n    }\n\n    .providerAppRowGrid {\n        grid-template-columns: 100%;\n    }\n\n    .providerAppImageWrapper {\n        height: 370px;\n    }\n\n    .providerAppHeading {\n        font-size: 24px;\n        line-height: 32px;\n        margin: 0 0 16px;\n    }\n\n    .providerAppDesc {\n        font-size: 16px;\n        line-height: 24px;\n        margin: 0 0 24px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"providerAppBgWrapper": `SignupGrid-providerAppBgWrapper-B_zXn`,
	"providerAppRowGrid": `SignupGrid-providerAppRowGrid-bTinu`,
	"providerAppHeading": `SignupGrid-providerAppHeading-y4XUi`,
	"providerAppDesc": `SignupGrid-providerAppDesc-AtJPM`,
	"providerAppBtnGroup": `SignupGrid-providerAppBtnGroup-pE0Gw`,
	"providerAppBtnLink": `SignupGrid-providerAppBtnLink-XrM6S`,
	"providerAppImageWrapper": `SignupGrid-providerAppImageWrapper-Wqj2Y`,
	"noTopCategoryBottomSpace": `SignupGrid-noTopCategoryBottomSpace-aA2Pq`
};
module.exports = ___CSS_LOADER_EXPORT___;
